import styled from "styled-components"

const BackToDashboardButtonStyled = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: ${({ theme }) => theme.palette.grey10};
  cursor: pointer;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.grey20};
  }

  .icon-back {
    color: ${({ theme }) => theme.palette.grey60};
    font-size: 1.5rem;
  }

  span {
    color: ${({ theme }) => theme.palette.grey60};
    font-size: 0.95rem;
    font-weight: 500;
  }
`

export default BackToDashboardButtonStyled

